module.exports = __webpack_public_path__ + "static/media/home-site.171bf2fa.png";